import { get, post, put } from "../Service/ApiConfig";
import { SpecialtyEndPoint } from "../Service/Endpoints/ApiEndPoints";

/**
 * Fetch all specialties with pagination, search, and language support.
 */
export const getAllSpecialties = async ({ page, size, searchText, language }) => {
  const response = await get(
    SpecialtyEndPoint.GetSpecialties(page, size, searchText, language)
  );
  return response;
};

/**
 * Get specialty by ID.
 */
export const getSpecialtyByID = async ({ id }) => {
  const response = await get(SpecialtyEndPoint.GetSpecialtyByID(id));
  return response;
};

/**
 * Update a specialty.
 */
export const updateSpecialty = async ({ specialty }) => {
  const response = await put(
    SpecialtyEndPoint.updateSpecialty,
    JSON.stringify(specialty)
  );
  return response;
};

/**
 * Add a new specialty.
 */
export const addSpecialty = async ({ specialty }) => {
  const response = await post(
    SpecialtyEndPoint.AddSpecialties,
    JSON.stringify(specialty)
  );
  return response;
};

export const deleteSpecialty = async ({ specialty }) => {
  
  if (!specialty || !specialty.specId) {
    console.error("deleteSpecialty requires an object containing specialty.specId");

    return { type: 1, message: "Missing specId for deletion request." };
  }

  const response = await put( 
    SpecialtyEndPoint.deleteSpecialty, 
    JSON.stringify(specialty) 
  );
  return response;
};